import { useCallback, useState } from 'react';

/**
 * One-shot “show me where” UX: scroll to a row and open its ⋯ menu.
 * Reusable for guided demos (create project, etc.).
 *
 * Pair with ContextMenu `forceOpen` / `onOpenChange` and optional `preferCreateProject`.
 */
export function useGuidedRowMenu(dataAttribute: string) {
  const [guidedId, setGuidedId] = useState<string | null>(null);

  const openGuidedMenu = useCallback(
    (id: string) => {
      setGuidedId(id);
      window.setTimeout(() => {
        const el = document.querySelector(
          `[${dataAttribute}="${CSS.escape(id)}"]`
        ) as HTMLElement | null;
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 100);
    },
    [dataAttribute]
  );

  const closeGuidedMenu = useCallback(() => {
    setGuidedId(null);
  }, []);

  return { guidedId, openGuidedMenu, closeGuidedMenu };
}
